// Cart drawer recommendations (snippets/ksl-cart-recommendations.liquid).
// 1. Swap the collection list for Shopify recommendations of the first cart item (complementary, then related).
// 2. Quick add for standard single-variant pieces, re-rendering the drawer the same way Dawn's product form does.
if (!customElements.get('ksl-cart-recommendations')) {
  const responses = new Map(); // per page view: drawer re-renders on every cart change

  customElements.define('ksl-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      if (this.dataset.source === 'smart' && this.dataset.productId) this.loadRecommendations();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    async loadRecommendations() {
      const limit = Math.min(10, Number(this.dataset.limit || 3) + Number(this.dataset.cartCount || 0));
      for (const intent of ['complementary', 'related']) {
        const url = `${this.dataset.url}?section_id=ksl-cart-recommendations&product_id=${this.dataset.productId}&limit=${limit}&intent=${intent}`;
        try {
          if (!responses.has(url)) responses.set(url, fetch(url).then((response) => (response.ok ? response.text() : '')));
          const html = await responses.get(url);
          const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ksl-cart-recs-list]');
          if (list && list.querySelector('li')) {
            this.querySelector('[data-ksl-cart-recs-list]')?.replaceWith(document.importNode(list, true));
            this.dataset.loaded = intent;
            return;
          }
        } catch (error) {
          // Keep the collection list.
        }
      }
      this.dataset.loaded = 'collection';
    }

    onClick = (event) => {
      const button = event.target.closest('[data-ksl-quick-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      this.quickAdd(button);
    };

    async quickAdd(button) {
      const variantId = Number(button.dataset.kslQuickAdd);
      const error = this.querySelector('[data-ksl-cart-recs-error]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;
      try {
        const response = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add to cart');
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ksl-cart-recommendations', productVariantId: variantId, cartData: state });
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents({ ...state, id: variantId });
        else window.location.href = routes.cart_url;
      } catch (err) {
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
